import React from "react";
import PropTypes from "prop-types";
import { FormSection } from "redux-form";
import PartDetails from "MODULES/IncomingQuotes/PartDetails";

export default function PartDetailsForm({
  cost,
  quantity,
  quoteType,
  selectedPart,
  taggedBy
}) {
  return (
    <FormSection name="">
      <PartDetails
        part={selectedPart}
        quantity={quantity}
        cost={cost}
        quoteType={quoteType}
        taggedBy={taggedBy}
      />
    </FormSection>
  );
}

PartDetailsForm.propTypes = {
  cost: PropTypes.string,
  quoteType: PropTypes.string,
  quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedPart: PropTypes.instanceOf(Object),
  taggedBy: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/Parts/PartDetails.jsx